// extracted by mini-css-extract-plugin
var _1 = "DocFlowMappingTypeWidget-modulenotification__gIxe2";
export { _1 as "notification" }
